import React from "react";
import { createIcon } from "@chakra-ui/icons";

export const Vegan = createIcon({
  displayName: "Vegan",
  viewBox: "0 0 24 24",
  defaultProps: {
    role: "img"
  },
  path: (
    <>
      <title> vegan icon </title>
      <path
        fill="currentColor"
        d="M19.262 4.11101C17.967 4.06201 16.712 4.43401 15.638 5.15901C15.275 5.40501 14.952 5.72501 14.707 6.08501C13.983 7.14801 13.612 8.43801 13.66 9.72001C13.661 9.73701 13.671 9.76101 13.68 9.78401C12.215 11.945 11.45 14.262 11.057 16.085C10.495 12.703 8.93999 7.48001 4.60599 4.08101C4.44099 3.95101 4.20599 3.98101 4.07999 4.14401C3.95199 4.30701 3.97999 4.54301 4.14299 4.67001C10.549 9.69501 10.63 19.28 10.63 19.376C10.63 19.583 10.798 19.751 11.005 19.751C11.212 19.751 11.38 19.583 11.38 19.376C11.38 19.313 11.44 14.414 14.299 10.204C14.323 10.204 14.347 10.205 14.371 10.205C15.588 10.205 16.759 9.84701 17.771 9.16301C18.133 8.91801 18.456 8.59701 18.703 8.23401C19.435 7.15401 19.798 5.89501 19.75 4.60601C19.75 4.33601 19.532 4.11501 19.262 4.11101ZM18.082 7.81401C17.889 8.09901 17.637 8.35101 17.352 8.54301C16.603 9.04901 15.753 9.33701 14.865 9.42001C15.624 8.45401 16.543 7.54401 17.668 6.76601C17.839 6.64801 17.881 6.41401 17.764 6.24401C17.645 6.07401 17.41 6.03401 17.243 6.14901C16.139 6.91201 15.233 7.79701 14.467 8.73401C14.584 7.94101 14.875 7.17401 15.327 6.51001C15.519 6.22801 15.772 5.97601 16.058 5.78401C16.936 5.19201 17.95 4.87501 19.004 4.86101C18.996 5.91601 18.68 6.93301 18.082 7.81401Z"
      />
    </>
  )
});
